// src/components/StatesGrid.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api/api";
import states from "../data/statesData";
import "./StatesGrid.css";

export default function StatesGrid({ compact = false }) {
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCounts();
  }, []);

  const fetchCounts = async () => {
    try {
      const res = await API.get("/states/count/all");
      setCounts(res.data.data || {});
    } catch (err) {
      console.error("State counts load failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`sg-wrapper ${compact ? "compact" : ""}`}>
      <div className="sg-grid">
        {states.map((item) => {
          const Icon = item.icon;
          const count = counts[item.name] ?? 0;

          return (
            
            <div
              key={item.name}
              className="sg-card"
              onClick={() => navigate(`/state/${encodeURIComponent(item.name)}`)}
            >
              
              <div className="sg-icon-box">
                <Icon className="sg-icon" />
              </div>

              <div className="sg-name">{item.name}</div>

              {loading ? (
                <div className="sg-count skeleton"></div>
              ) : (
                <div className="sg-count">{count} Schemes</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
